import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo'
import {filterResource} from "../helpers/filters";

interface Data {
    paragraphById: {
        fieldVarLinkTarget: string;
        fieldVarButtonStyle: string;
        fieldImagesDemoMedia: Array<{
            entity: Array<{
                fieldMediaImage: Array<{
                    width: string;
                    height: string;
                    url: string;
                    targetId: string;
                    alt: string;
                    title: string;
                }>;
            }>;
        }>;
    }
}

class ImagesQuery extends Query<Data, {id: string}> {}

const GET_IMAGES = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphImages {
          fieldImagesDemoMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    targetId
                    alt
                    title
                  }
                }
              }
          }
        }
      }
    }
  }
}
`;

const Images = ({id, markComponentLoadedAs}) => (
    <ImagesQuery asyncMode query={GET_IMAGES} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            if (!field.fieldImagesDemoMedia || !Object.keys(field.fieldImagesDemoMedia).length) {
                markComponentLoadedAs(id, true);
                return null;
            }

            markComponentLoadedAs(id, true);

            return (
                <div className="images">
                    <div className="images__image">
                        {field.fieldImagesDemoMedia.filter(image => image.entity.fieldMediaImage.url !== '').map(image => (
                            <img key={`image_${image.entity.fieldMediaImage.targetId}`}
                                 src={filterResource(image.entity.fieldMediaImage.url)}
                                 alt={image.entity.fieldMediaImage.title}/>
                        ))}
                    </div>
                </div>
            );
        }}
    </ImagesQuery>
);

Images.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default Images;



// WEBPACK FOOTER //
// ./frontend/components/Images.jsx